import { render, staticRenderFns } from "./ApproveListAppeal.vue?vue&type=template&id=6d3c13cc&scoped=true"
import script from "./ApproveListAppeal.vue?vue&type=script&lang=js"
export * from "./ApproveListAppeal.vue?vue&type=script&lang=js"
import style0 from "./ApproveListAppeal.vue?vue&type=style&index=0&id=6d3c13cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c13cc",
  null
  
)

export default component.exports